'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var eventMap = {
  click: function click(handler) {
    document.body.addEventListener('click', function (e) {
      // trigger default event, while handle custom-events
      handler(e);

      // trigger global 'click' event
      handler({
        eventName: 'click',
        target: e.target,
        content: {
          pageX: e.pageX,
          pageY: e.pageY
        }
      });
    }, false);
  },
  error: function error(handler) {
    window.addEventListener('error', function (e) {
      var error = e.error;


      handler({
        eventName: 'error',
        content: {
          // will change property name
          content: error && error.stack
        }
      });
    }, false);
  },
  load: function load(handler) {
    var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    window.addEventListener('load', function () {
      var _defaultParams$exclud = defaultParams.excludeEvent,
          excludeEvent = _defaultParams$exclud === undefined ? [] : _defaultParams$exclud;

      if (!Array.isArray(excludeEvent)) excludeEvent = [];
      if (window.performance) {
        var timing = window.performance.timing;
        if (timing) {
          var navigation = window.performance.navigation;

          var firstPaintTime = null;
          if (window.chrome && window.chrome.loadTimes) {
            var loadTimes = window.chrome.loadTimes();
            firstPaintTime = loadTimes.firstPaintTime - loadTimes.startLoadTime;
          } else if (timing.msFirstPaint) {
            firstPaintTime = timing.msFirstPaint - timing.navigationStart;
          }

          if (!excludeEvent.includes('performance-timing')) {
            handler({
              eventName: 'performance-timing',
              content: {
                duration: timing.responseEnd - timing.navigationStart,
                redirect: timing.redirectEnd - timing.redirectStart,
                appCache: timing.domainLookupStart - timing.fetchStart,
                dnsTime: timing.domainLookupEnd - timing.domainLookupStart,
                connect: timing.connectEnd - timing.connectStart,
                fetchFirstByte: timing.responseStart - timing.navigationStart,
                firstPaintTime: firstPaintTime,
                requestTime: timing.responseStart - timing.requestStart,
                responseTime: timing.responseEnd - timing.responseStart,
                domReady: timing.domInteractive - timing.navigationStart,
                onLoadTime: timing.loadEventEnd - timing.navigationStart,
                navigationType: navigation ? navigation.type : null,
                navigationRedirectCount: navigation ? navigation.redirectCount : null
              }
            });
          }
        }

        if (window.performance.getEntriesByType && !excludeEvent.includes('resource-timing')) {
          var resourceTimingList = window.performance.getEntriesByType('resource');
          if (resourceTimingList && resourceTimingList.length > 0) {
            var supportedTypes = ['script', 'link', 'css'];

            resourceTimingList.filter(function (item) {
              return supportedTypes.indexOf(item.initiatorType) !== -1;
            }).map(function (item) {
              return {
                initiatorType: item.initiatorType,
                size: item.transferSize,
                duration: item.duration,
                redirect: item.redirectEnd - item.redirectStart,
                appCache: item.domainLookupStart - item.fetchStart,
                dnsTime: item.domainLookupEnd - item.domainLookupStart,
                connect: item.connectEnd - item.connectStart,
                fetchFirstByte: item.responseStart - item.startTime,
                requestTime: item.responseStart - item.requestStart,
                responseTime: item.responseEnd - item.responseStart
              };
            }).forEach(function (content) {
              return handler({
                eventName: 'resource-timing',
                content: content
              });
            });
          }
        }
      }
    }, false);
  },
  hashchange: function hashchange(handler) {
    window.addEventListener('hashchange', function () {
      handler({ eventName: 'hashchange' });
    }, false);
  },
  popstate: function popstate(handler) {
    window.addEventListener('popstate', function () {
      handler({ eventName: 'popstate' });
    }, false);
  }
};

// register 'click', 'error' and 'load' events
function registerEventsHandler(handler) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaultParams$exclud2 = defaultParams.excludeEvent,
      excludeEvent = _defaultParams$exclud2 === undefined ? [] : _defaultParams$exclud2;

  if (!Array.isArray(excludeEvent)) {
    excludeEvent = [];
  }
  Object.keys(eventMap).forEach(function (key) {
    if (excludeEvent.includes(key)) return;
    eventMap[key](handler, defaultParams);
  });
}

exports.default = registerEventsHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kryfe/divolte/es/registerEventsHandler.js
// module id = 245
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 70 71